<template>
    <div>
        <div v-if="showSizeForm == false" class="d-flex border-bottom py-3 align-items-center text-center">
            <div class="col-6 text-end pe-2">
                <b class="d-block">Need {{ tyrePositionText }} tyres?</b>
            </div>
            <div class="col-6 text-start ps-2">
                <button type="button" class="btn btn-success" @click="addMoreTyres()" >Add {{ tyrePositionText }} tyres</button>
            </div>
        </div>
        <div v-else class="border-bottom text-center py-3">
            <b class="d-block mb-2">Select your {{ tyrePositionText }} tyre size</b>
            <confirm-size-options
                :options="car.options"
                :errors="errors"
                :hide-position="tyrePosition"
                :updateSizeOptions="true"
                @updateSelectedOption="updateSelectedOption"
            ></confirm-size-options>
            <b class="d-block mb-2">Not the right size? Enter the correct size below</b>
            <size-form
                :postcode="postcode"
                :options="sizeOptions"
                :tyre-position="tyrePositionText"
                :selected-size-option="selectedSizeOption"
            ></size-form>
            <b
                @click="toggleSizeForm()" 
                class="d-inline-block text-danger text-underline cursor-pointer mt-2"
            >I don't need {{ tyrePositionText }} tyres</b>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'tyrePosition',
            'tyrePositionText',
            'postcode',
            'sizeOptions',
            'errors'
        ],
        data() {
            return {
                showSizeForm: false,
                car: {},
                selectedSizeOption: {}
            }
        },
        methods: {
            toggleSizeForm() {
                this.showSizeForm = !this.showSizeForm;
                this.emitter.emit('toggleDisabled');
            },
            updateSelectedOption(data) {
                //This prepopulates the size-form component with the selected size options.
                let split = window._split([data], '/');
                let speed = split[3].charAt(0).toUpperCase();

                if(typeof(split) != 'undefined') {
                    this.selectedSizeOption = {width: split[0], profile: split[1], rim: split[2], speed: speed};
                }
            },
			async addMoreTyres() {
                this.emitter.emit('toggleDisabled');
                this.emitter.emit('isLoading', true);

				let response = await axios.get('/get-car');

				if(response.data != null) {
					this.showSizeForm = true;
					this.car = response.data;
				}
                
                this.emitter.emit('isLoading', false);
			}
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>

</style>